import { render, staticRenderFns } from "./EFormPessoaFisica.vue?vue&type=template&id=aa55ee92&scoped=true"
import script from "./EFormPessoaFisica.vue?vue&type=script&lang=js"
export * from "./EFormPessoaFisica.vue?vue&type=script&lang=js"
import style0 from "./EFormPessoaFisica.vue?vue&type=style&index=0&id=aa55ee92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa55ee92",
  null
  
)

export default component.exports